import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'loyaltic-support-rules',
    templateUrl: './support-rules.component.html',
    styleUrls: ['./support-rules.component.scss'],
    standalone: false
})
export class SupportRulesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
